import LinkedAccountServiceCard from '@/features/agent/linked_accounts/components/LinkedAccountServiceCard';
import useFetchIam from '@/features/agent/api/useFetchIam';
import {
  SERVICES,
  filterServicesByOrganization,
} from '@/features/agent/linked_accounts/constants/services';

type Props = {
  onServiceSelect: (service: { name: string; imageUrl: string; sourceType: string }) => void;
};

export default function TrialAccountLinkStep1({ onServiceSelect }: Props) {
  const { data: iam } = useFetchIam();
  const organizationId = iam?.current_organization?.id;

  const filteredServices = filterServicesByOrganization(SERVICES, organizationId);

  return (
    <div className="relative z-10 flex h-[526px] w-[940px] flex-col items-center">
      <div className="flex flex-col items-center gap-xl">
        <p className="text-3xl leading-[1.2] font-bold">連携先アカウント設定</p>
        <p className="text-base text-black/70">
          求人票をエージェントハブに取り込みます。連携したいアカウントを選択してください。
        </p>
      </div>
      <div className="hidden-scrollbar mt-lg flex h-[400px] w-full justify-center overflow-y-auto py-1">
        <div className="grid grid-cols-3 gap-md">
          {filteredServices.map((service) => (
            <LinkedAccountServiceCard
              key={service.sourceType}
              imageUrl={service.imageUrl}
              name={service.name}
              onClick={() =>
                onServiceSelect({
                  name: service.name,
                  imageUrl: service.imageUrl,
                  sourceType: service.sourceType,
                })
              }
            />
          ))}
        </div>
      </div>
    </div>
  );
}
